<template>
  <div class="member-wrap">
      <pageTitle :extinfo="extinfo"></pageTitle>
      <div class="member-head flex-col">
      <!-- 背景图片 -->
      <van-image class="member-head-bg" style="pointer-events:none;" :src="artistInfo.coverUrl+'?x-oss-process=image/resize,l_750'" fit="cover " />
      <!-- 头像 -->
      <div class="member-user-head-box">
        <van-image
          style="pointer-events:none;"
          width="90"
          height="90"
          :src="artistInfo.avatar+'?x-oss-process=image/resize,l_200'"
          round
          fit="cover"
          class="img"
        />
        <div class="menber-user">
          <div class="menber-user-name">
            {{ artistInfo.nickname ? artistInfo.nickname : '昵称' }}
          </div>
          <div class="menber-user-arr">
            <template v-if="artistInfo.province">
              {{ artistInfo.province ? artistInfo.province : '暂无地址' }}
            </template>
            <div v-else>
              该艺术家暂无简介哦~
              <!-- <van-image src="https://img01.yzcdn.cn/vant/cat.jpeg"
                         mode="aspectFill"
                         fit="contain" /> -->
            </div>
          </div>
        </div>
      </div>
        <div class="member-follow">
          <div class="unfollow" >
            <van-image width="12" height="12" :src="require('@/assets/jia_b_icon.png')" fit="cover" />
            关注</div>
          <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
            <template>
                <script type="text/wxtag-template">
                  <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
                  此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
                  </div>
              </script>
            </template>
          </wx-open-launch-app>
        </div>
    </div>

    <div style="z-index: 99; transform: translateY(-15px)">

      <!-- 个人信息 -->
      <div class="member-user flex-col">
      <div class="member-desc flex-row">
        <div class="member-desc-first" @click="toWorkLib()">作品 {{ artistInfo.nickname == '云上兰亭' ? worksList.length : artistInfo.worksCount }}</div>
        <div @click="toGallery()">美术馆 {{ artistInfo.isArtUser }}</div>
        <div class="member-desc-last" @click="toArtList()">相关资讯 {{ infoTotal }}</div>
        <!-- <div class="member-comment">
          <img src="@/assets/pl_icon.png" />
        </div> -->
      </div>
        <!-- 个人数据关注数，粉丝数，浏览人数 -->
        <!-- <div class="member-user-top flex-row">
          <div class="member-user-top-left">
            <div class="member-user-bd flex-col">
              <span class="member-user-num">{{
                artistInfo.concernCount ? artistInfo.concernCount : 0
              }}</span
              ><span>关注</span>
            </div>
            <div class="member-user-bd flex-col">
              <span class="member-user-num">{{
                artistInfo.fanCount ? artistInfo.fanCount : 0
              }}</span
              ><span>粉丝</span>
            </div>
          </div>
          <div class="member-user-top-right">
            <div class="member-user-bd flex-col">
              <div class="member-user-num">
                {{ artistInfo.browseCount ? artistInfo.browseCount : 0 }}人浏览
              </div>
            </div>
          </div>
        </div> -->
        <!-- 个人头衔 -->
        <div class="section-title"><div class="left-line"></div>个人介绍</div>
        <div class="user-job-list flex-row" v-if="titleList[0]">
          <div class="user-job" v-for="title in titleList" :key="title">
            {{ title }}
          </div>
        </div>
        <!-- 个人介绍 -->
        <div class="user-update flex-row">
          <span id="user-update-txt" class="user-update-txt" :class="{'expend': !isExpend}">{{
            artistInfo.brief ? artistInfo.brief : '点击添加介绍，让大家认识你'
          }}</span>
        </div>
          <div v-if="needExpend && !isExpend" @click="expendBrief(true)" class="opexpend">展开详情</div>
          <div v-if="needExpend && isExpend" @click="expendBrief(false)" class="opexpend">收起详情</div>
        <!-- 个人美术馆 -->
        <div class="section-title" v-if="artistInfo.isArtUser">
          <div class="left-line"></div>
          个人美术馆
        </div>
        <div class="art-gallery-box">
          <art-gallery
        v-if="artistInfo.isArtUser"
        :galleryId="artistInfo.galleryId"
        :galleryCoverList="artistInfo.galleryCoverList"
        :galleryName="galleryName"
        :galleryDesc="artistInfo.galleryDesc"
        @click="toGallery()"></art-gallery>
        </div>

        <!-- 热门作品 -->
        <div class="section-title">
          <div class="left-line"></div>
          热门作品
          <span class="more"  @click="toWorkLib" v-if="worksList.length > 0">
            更多<img src="@/assets/more_icon.png" />
          </span>
        </div>
        <div class="user-works-box">
          <div class="works-list">
            <template
                v-for="(item, index) in worksList">
              <works
                @prioimg="toWorkDetail"
                :item="item"
                :key="index"
                v-if="index < 10"
              ></works>
            </template>
            <div v-if="worksList.length == 0" class="nowork">
              <van-image
                :src="require('@/assets/kong_zp.png')"
                width="140"
                height="128"
              ></van-image>
              <div class="noworktips">暂无作品</div>
            </div>
          </div>
        </div>
        <!-- 相关资讯 -->
        <div class="section-title" v-if="infoList.length > 0">
          <div class="left-line"></div>
          相关资讯
          <span class="more" @click="toArtList()">
            更多
            <img src="@/assets/more_icon.png" />
          </span>
        </div>
        <div class="user-info-box">
          <div class="info-list">
            <template
              v-for="(item, index) in infoList">
              <infos
              :key="index"
              :item="item"
              v-if="index < 3"
              ></infos>
            </template>
          </div>
        </div>
        <div class="comment-box">
          <commen-list :isBord="true" :commentList="commentList" :likeTotal="likeTotal" :commentTotal="commentTotal"></commen-list>
        </div>
      </div>
      <div class="user-works-list"></div>
    </div>
    <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
    <common-ct :extinfo="extinfo" @share="share" @common="common" @like="like" :like-count="artistInfo.likeCount" :comment-count="commentTotal"></common-ct>
    <unilt-webgl v-if="show" :galleryId="artistInfo.galleryId"  @close="show=!show"></unilt-webgl>
  </div>
</template>

<script>
import { getGalleryWorkeList } from '@/api/gallery'
import { getArtistInfo, getArtistWorks, getInfoReport } from '@/api/artist'
import { queryCommentLikeTotal, queryCommentList } from '@/api/artinfo'
import { changeTitleClick, wexinShare } from '@/utils/utils'
import { queryShart, queryWxUserInfo } from '@/api/user'
import Works from '@/components/works/works.vue'
import Infos from '@/components/infos/infos.vue'
import artGallery from '@/components/artGallery/artGallery.vue'
import commonCt from '@/components/commonCt/commonCt.vue'
import commenList from '@/components/commenList/commenList.vue'
import uniltWebgl from '@/components/uniltWebgl/index.vue'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
export default {
  name: 'ShareView',
  components: {
    Infos,
    Works,
    artGallery,
    commonCt,
    commenList,
    uniltWebgl,
    pageTitle,
    pageFoot
  },
  data () {
    return {
      active: 0, // tabs的索引
      show: false, // 控制popup显示与隐藏
      artistInfo: {
        nickname: '',
        province: '',
        concernCount: '',
        fanCount: '',
        browseCount: 0,
        brief: '',
        galleryId: 0,
        titleList: []
      }, // 艺术家信息
      titleList: [], // 艺术家头衔
      worksList: [], // 艺术家作品
      galleryId: 0, // 美术馆id
      userId: 0, // 艺术家id
      artCommentList: [], // 展厅评论
      commentList: [], // 总评论列表
      commentTotal: 0, // 评论数
      likeTotal: 0, // 点赞数
      pageNo: 1,
      pageSize: 10,
      extinfo: 'yslt://?name=galleryPerson&',
      // 微信code
      code: '',
      // 微信用户信息
      wxUserInfo: '',
      infoTotal: 0,
      infoList: [],
      galleryName: '',
      imageList: [],
      needExpend: false,
      isExpend: true,
      isSuspension: false // 控制是否显示打开APP
    }
  },
  async created () {
    // console.log(window.location.href)
    await this.getA()
    if (localStorage.getItem('code') === '') {
      location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd195d7f108eab952&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=123&forcePopup=true#wechat_redirect`)
    }
    await this.getArtist()
    await this.getInfoTotal()
    this.extinfo = this.extinfo + `userId=${this.userId}`
    await this.queryCommentList()
    await this.queryCommentLikeTotal()
    if (this.artistInfo.nickname === '云上兰亭') {
      await this.getWorkeList()
    } else {
      await this.getArtistWorks()
    }
    this.weixin()
    this.changeTitleClick()
    this.checkBrief()
  },
  computed: {
    detailsList () {
      return [{ tab: '人物简介', text: this.artistInfo.brief }]
    },
    tabs () {
      return ['全部作品', ...this.worksList.map((v) => v.title)]
    }
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    toGallery () {
      localStorage.setItem('__jump', 1)
      if (this.artistInfo.isArtUser === 1) {
        const url = `http://room.yslt.art/SharePageTest/?userId=${this.userId}&galleryId=${this.artistInfo.galleryId}#/unilty`
        window.location.href = url
      }
    },
    toWorkLib () {
      if (this.worksList.length <= 0) {
        return false
      }
      const url = `http://room.yslt.art/SharePageTest/?userId=${this.userId}&name=${this.artistInfo.nickname}#/workLib`
      window.location.href = url
    },
    toWorkDetail (id) {
      if (this.artistInfo.nickname === '云上兰亭') {
        let position = 0
        this.worksList.forEach((item, index) => {
          if (item.id === id) {
            position = index
          }
        })
        this.ImagePreview({ images: this.imageList, startPosition: position })
      } else {
        localStorage.setItem('__jump', 1)
        const url = `http://room.yslt.art/SharePageTest/?id=${id}#/workDetail`
        window.location.href = url
      }
    },
    toArtList () {
      if (this.infoTotal <= 0) {
        return false
      }
      const url = `http://room.yslt.art/SharePageTest/?userId=${this.userId}&name=${this.artistInfo.nickname}#/artlist`
      window.location.href = url
    },
    expendBrief (expend) {
      this.isExpend = expend
    },
    async checkBrief () {
      const style = window.getComputedStyle(document.getElementById('user-update-txt'), null)
      const fontSize = style.fontSize
      const height = style.height.replace('px', '')
      const lineHeight = (style.lineHeight === 'normal' ? fontSize : style.lineHeight).replace('px', '')

      const line = height / lineHeight
      if (line > 2) {
        this.needExpend = true
        this.isExpend = false
      }
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    // 获取艺术家个人信息
    async getArtist () {
      try {
        const res = await getArtistInfo(this.userId)
        this.artistInfo = res.result
        this.titleList = res.result.titleList ? res.result.titleList.split(',') : []
        this.galleryName = this.artistInfo.nickname + ' · ' + (this.artistInfo.galleryName ? this.artistInfo.galleryName : '云上美术馆')
      } catch (error) {
        console.log('获取艺术家个人信息失败', error)
      }
    },
    // 获取艺术家资讯
    async getInfoTotal () {
      try {
        const res = await getInfoReport(this.userId)
        this.infoList = res.result.records
        this.infoTotal = res.result.total
      } catch (error) {
        console.log('获取艺术家资讯失败', error)
      }
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    },
    // 获取艺术家作品
    async getArtistWorks () {
      try {
        const res = await getArtistWorks(this.artistInfo.id)
        this.worksList = res.result
        this.worksList.forEach((item, index) => {
          this.imageList[index] = item.coverUrl
        })
      } catch (error) {
        console.log('获取艺术家作品失败', error)
      }
    },
    // 获取官方美术馆作品列表
    async getWorkeList () {
      try {
        const that = this
        const res = await getGalleryWorkeList('1544991314419613698')
        this.worksList = res.result
        this.worksList.forEach((item, index) => {
          if (index < 10) {
            that.imageList[index] = item.coverUrl
          }
        })
      } catch (error) {
        console.log('获取作品列表失败', error)
      }
    },
    // 修改微信的网页标题
    changeTitleClick () {
      const title = this.artistInfo.nickname + '-云上兰亭艺术家'
      changeTitleClick(title)
    },
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.userId = obj.userId
      this.galleryId = obj.galleryId
      this.code = obj.code || ''
      // 本地存入code
      localStorage.setItem('code', obj.code)
    },
    // 打开云展厅方法
    openGallery (galleryId) {
      this.$router.push({
        name: 'unilty',
        query: {
          galleryId
        }
      })
    },
    // 预览图片
    proImag (img) {
      this.ImagePreview({ images: img })
    },
    // 获取评论列表
    async queryCommentList () {
      try {
        const res = await queryCommentList({
          topicId: this.userId,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        this.commentList = res.result.records
        this.commentTotal = res.result.total
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 获取评论点赞
    async queryCommentLikeTotal () {
      try {
        const res = await queryCommentLikeTotal({
          topicId: this.userId
        })
        this.likeTotal = res.result.likeCount
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      wexinShare(res.result, {
        title: this.artistInfo.nickname + '个人美术馆',
        desc: this.artistInfo.brief,
        link: window.location.href,
        imgUrl: this.artistInfo.avatar
      })
    },
    // 获取微信用户信息
    async getWxUserInfo () {
      try {
        const res = await queryWxUserInfo(this.code)
        this.wxUserInfo = res.result
      } catch (error) {
        console.log('获取微信用户信息失败', error)
      }
    },
    getAuth () {
      const redirect = encodeURIComponent(window.location.href)
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd195d7f108eab952&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=123&forcePopup=true#wechat_redirect`
    },
    share () {
      // copy(window.location.href)
      // window.open('http://room.yslt.art/art/openapp.html', '_blank')
    },
    common () {
      // window.open('http://room.yslt.art/art/openapp.html', '_blank')
    },
    like () {
      // window.open('http://room.yslt.art/art/openapp.html', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-line {
    width: 2px;
    height: 14px;
    background: linear-gradient(0deg, rgba(248, 243, 234, 0.3) 0%, #BCA992 100%);
    margin-right: 8px;
    display: inline-block;
}
.member-wrap {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f2f2f2;
  padding-bottom: 48px;
  .member-head {
    width: 100%;
    height: 220px;
    padding-bottom: 5px;
    position: relative;
    .masking {
    position: absolute;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.64) 0%, rgba(0, 0, 0, 0.15) 100%);
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
  }
    .member-head-bg {
      position: absolute;
      z-index: 0;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .preview,
    .setting {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 55px;
    }

    .preview {
      right: 64px;
    }

    .setting {
      right: 17px;
    }

    .member-user-head-box {
      position: absolute;
      top: 165px;
      left: 17px;
      display: flex;
      align-items: center;
      z-index: 999;
      .img {
        border: #fff solid 1px;
      }
      .member-user-head {
        width: 148px;
        height: 148px;
        border-radius: 50%;
        border: #fff 1px solid;
      }

      .menber-user {
        margin-left: 16px;
        line-height: 1;
        margin-top: 60px;

        .menber-user-name {
          font-size: 24px;
          font-family: PingFang-SC-Heavy;
          margin-bottom: 15px;
          color: #333;
          font-weight: bold;
          display: inline-block;
        }

        .menber-user-arr {
          color: #666;
          font-size: 14px;
          font-weight: PingFang-SC-Medium;
          display: flex;
          align-items: center;
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;

          > image {
            width: 12px;
            height: 15px;
            margin-right: 6px;
          }
        }
      }
    }

    .member-follow {
        position: absolute;
        right: 17px;
        top: 225px;
        z-index: 999;
        .unfollow {
          width: 68px;
          height: 28px;
          background: #CC0909;
          border-radius: 14px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
  }

  .member-user {
    width: 375px;
    padding: 74px 0 30px 0;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    box-sizing: border-box;

    .member-desc {
      color: #333;
      font-size: 14px;
      position: relative;
      padding: 0 17px;
      .member-comment {
        position: absolute;
        right: 0;
        top: -8px;
        background-color: #F9F7F6;
        border-radius: 40px;
        padding: 8px;
        display: flex;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .member-desc-first {
        margin-right: 20px;
        padding-right: 20px;
        border-right: 1px solid #CCCCCC;
      }
      .member-desc-last {
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid #CCCCCC;
      }
    }

    .member-user-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .member-user-top-left {
        display: flex;

        .member-user-bd {
          display: flex;
          align-items: flex-end;
          flex-direction: row;
          font-family: PingFang-SC-Heavy;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-right: 15px;
          line-height: 1;

          > text {
            line-height: 1;
          }

          .member-user-num {
            font-size: 18px;
            margin-right: 5px;
            line-height: 1;
            font-family: PingFang SC;
            font-weight: 800;
          }
        }
      }

      .member-user-top-right {
        .member-user-num {
          color: #727272;
          font-size: 12px;
          font-family: PingFang-SC-Medium;
        }
      }
    }

    .user-job-list {
      margin: 0 0 12px;
      flex-wrap: wrap;
      padding: 0 17px;

      .user-job {
        line-height: 24px;
        font-size: 14px;
        color: #333;
        box-sizing: border-box;
        width: fit-content;

        &:last-child {
          margin: 0;
        }
      }
    }

    .user-update {
      align-items: center;
      padding: 0 17px;

      .user-update-txt {
        white-space: pre-line;
        line-height: 1.8;
        font-size: 15px;
        color: #434343;
      }

      .expend {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      .user-update-icon {
        width: 14px;
        height: 15px;
      }
    }
  }
  .section-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      padding: 30px 17px 16px 17px;
      .more {
       color: #999999;
       font-size: 13px;
       font-weight: 400;
       float: right;
       margin-top: 4px;

       img {
        height: 10px;
        width: auto;
        margin-left: 8px;
       }
      }

    }
  .user-works-box {
    margin-top: 6px;
    background-color: #fff;
    padding: 0 17px;
    .works-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      padding: 20px 10px;

    }
    .works-list {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.opexpend {
  color: #A26F43;
  margin-top: 6px;
  font-size: 14px;
  padding: 0 17px;
}
.nowork {
  margin: 20px 0;
  width: 100%;
  text-align: center;
  .noworktips {
    color: #999;
    font-size: 12px;
    margin-top: 18px;
  }
}

.openApp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.art-gallery-box, .comment-box {
  padding: 0 17px;
}
</style>
